import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { contentAPI } from "../api/endpoints";
import ContentRow from "../components/ContentRow";
import PageSkeleton from "../components/PageSkeleton";

export default function TvShows() {
  const navigate = useNavigate();
  const [sections, setSections] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    contentAPI
      .getTvShows()
      .then((res) => {
        // /api/series/launcher returns ArrayList<MovieContentResponse>
        setSections(res.data || []);
      })
      .catch(() => { })
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="pt-20">
        <div className="px-5 md:px-10 max-w-[1400px] mx-auto mb-8">
          <div className="w-40 h-8 bg-dark-700 rounded-md animate-pulse"></div>
          <div className="w-56 h-4 bg-dark-800 rounded-md mt-2 animate-pulse"></div>
        </div>
        <PageSkeleton withHero={false} />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-dark-900 pt-20 pb-16">
      <div className="px-5 md:px-10 max-w-[1400px] mx-auto mb-8">
        <h1 className="text-3xl font-bold text-white">TV Shows</h1>
        <p className="text-gray-500 text-sm mt-1">Browse TV shows by genre</p>
      </div>

      {sections.length > 0 ? (
        sections.map((section) => (
          <ContentRow
            key={section.id}
            title={section.title}
            items={section.data || []}
            type="series"
            onSeeAll={() => navigate(`/category?type=${encodeURIComponent(section.type)}&title=${encodeURIComponent(section.title)}&content_type=series`)}
          />
        ))
      ) : (
        <div className="text-center py-20 text-gray-500">
          <p className="text-lg">No TV shows available right now</p>
        </div>
      )}
    </div>
  );
}
